__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "inboxapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@pd-ui/core", "3.6.2", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(348), __webpack_require__.e(932), __webpack_require__.e(203), __webpack_require__.e(132), __webpack_require__.e(325), __webpack_require__.e(679)]).then(() => (() => (__webpack_require__(5184))))));
			register("@pd-ui/core", "4.1.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(348), __webpack_require__.e(567), __webpack_require__.e(932), __webpack_require__.e(203), __webpack_require__.e(132), __webpack_require__.e(325)]).then(() => (() => (__webpack_require__(4721))))));
			register("@pd-ui/icons", "2.22.3", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(348), __webpack_require__.e(325)]).then(() => (() => (__webpack_require__(3922))))));
			register("@tanstack/react-query", "4.44.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(348)]).then(() => (() => (__webpack_require__(5306))))));
			register("i18next", "22.0.2", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(402))))));
			register("jotai", "2.20.3", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(348)]).then(() => (() => (__webpack_require__(9264))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(348)]).then(() => (() => (__webpack_require__(961))))));
			register("react-hook-form", "7.45.2", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(348)]).then(() => (() => (__webpack_require__(9785))))));
			register("react-hook-form", "7.91.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(348)]).then(() => (() => (__webpack_require__(9703))))));
			register("react-i18next", "14.0.5", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(348)]).then(() => (() => (__webpack_require__(3710))))));
			register("react-i18next", "14.1.3", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(348)]).then(() => (() => (__webpack_require__(6559))))));
			register("react-router-dom", "6.14.1", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(348)]).then(() => (() => (__webpack_require__(2648))))));
			register("react/jsx-runtime", "18.2.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(348)]).then(() => (() => (__webpack_require__(4848))))));
			register("react", "18.2.0", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(6540))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(348)]).then(() => (() => (__webpack_require__(2568))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};